import {path} from 'ramda'
import {RootState} from 'store'
import {CommonErrorPayloadFormatType} from 'types/errorResponse'

import {ErrorResponse} from '@vio/core/src/booking/types/ErrorResponse'

import {ERROR} from './actions/error'

import type {PaymentMethodConfiguration} from 'services/payment/paymentMethods'

export type ErrorType = {
  errorResponse: ErrorResponse
  originalErrorAction: string
}

const getModuleState = (state: RootState) => state?.common?.moduleState

/**
 * Check whether any sold out type error happened in any API
 * Note this does not care about which API parameters were used, it is a global check
 */
export const didAnySoldOutErrorHappen = (state: RootState) => {
  if (getModuleState(state) === ERROR) {
    return state?.common?.error?.errorResponse?.details?.category === 'sold_out'
  }

  return state?.common?.error?.errorResponse?.details?.category === 'sold_out'
}

export const getError = path<CommonErrorPayloadFormatType>(['common', 'error'])

export const getHttpRequestId = (state: RootState) =>
  state.common?.httpRequestId || ''

// Offer check URL from APM redirect (e.g., Revolut redirect back to checkout)
export const getOfferCheckOverrideUrl = (state: RootState) =>
  state.common?.offerCheckOverrideUrl

export const getIsOfferCheckRefetch = (state: RootState) =>
  state.common?.isOfferCheckRefetch

export const getPspInitialized = (state: RootState): boolean =>
  state.common.isPspInitialized

export const getPayrailsInitialized = (state: RootState): boolean =>
  state.common.isPayrailsInitialized

export const getEnabledWallets = (
  state: RootState
): PaymentMethodConfiguration[] | null => state.common.enabledWallets

export const getIsEmbeddedWithKiwi = (state: RootState): boolean =>
  state.common.isEmbeddedWithKiwi
